"use client";

import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import ym, { YMInitializer } from "react-yandex-metrika";
import { checkCookiesConsent } from "./AcceptCookies";

const YM_COUNTER_ID = 105207607;

export const YandexMetrika = () => {
    const pathname = usePathname();
    const [hasConsent, setHasConsent] = useState<boolean | null>(null);

    useEffect(() => {
        // Проверяем согласие при монтировании
        const consent = checkCookiesConsent();
        setHasConsent(consent);

        // Слушаем изменения согласия
        const handleConsentChange = (event: CustomEvent) => {
            setHasConsent(event.detail.consented);
        };

        window.addEventListener('cookiesConsentChanged', handleConsentChange as EventListener);

        return () => {
            window.removeEventListener('cookiesConsentChanged', handleConsentChange as EventListener);
        };
    }, []);

    useEffect(() => {
        // Отправляем hit только если есть согласие
        if (hasConsent && pathname) {
            try {
                ym("hit", pathname);
            } catch (error) {
                console.error("Yandex Metrika hit error:", error);
            }
        }
    }, [pathname, hasConsent]);

    // Не загружаем метрику, если нет согласия или еще не проверили
    if (hasConsent !== true) return null;

    return (
        <YMInitializer
            accounts={[YM_COUNTER_ID]}
            options={{
                defer: true,
                webvisor: true,
                clickmap: true,
                trackLinks: true,
                accurateTrackBounce: true,
            }}
            version="2"
        />
    );
};